import gql from "graphql-tag"

export default gql`
  query ($locationId: [Int]) {
    content {
      folders(query: { ParentLocationId: $locationId }) {
        edges {
          node {
            shortTitle
            title
            titleHtml
            colorTag
            image {
              alternativeText
              variation(identifier: reference) {
                uri
              }
            }
            _location {
              id
              priority
              parentLocationId
              hidden
              content {
                _type {
                  identifier
                }
              }
              children {
                edges {
                  node {
                    id
                    hidden
                    priority
                    parentLocationId
                    content {
                      ... on SubjectContent {
                        id
                        title
                        shortTitle
                        _url
                        _type {
                          identifier
                        }
                        image {
                          alternativeText
                          variation(identifier: reference) {
                            uri
                          }
                        }
                        _info {
                          currentVersion {
                            versionNumber
                            creationDate {
                              timestamp
                            }
                            modificationDate {
                              timestamp
                            }
                          }
                          locations {
                            children {
                              totalCount
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
